import { Component, Type } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { filter, take, tap } from 'rxjs';
import { toggleSplashScreenVisibility } from 'projects/lib-shared-common/src/public-api';
import { defaultPublicLayoutConfig, PublicLayoutConfig } from './public-layout.config';
import { PublicLayout } from './public-layout.types';
import { PublicBaseLayoutComponent } from './layouts/public-base-layout.component';
import { BaseLayoutComponent } from '../shared/base-layout.component';

@Component({
  selector: 'svc-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
})
export class SvcPublicLayoutComponent extends BaseLayoutComponent<PublicLayout, PublicBaseLayoutComponent> {
  private _childLayoutResolved = false;

  protected get defaultLayoutConfig(): PublicLayoutConfig {
    return defaultPublicLayoutConfig;
  }

  constructor() {
    super();
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        tap(() => this._hideSplashWhenReady())
      )
      .subscribe();
  }

  public childLayoutWasResolved(): void {
    this._childLayoutResolved = true;
    this._hideSplashWhenReady();
  }

  protected override onStartupInitialized(): void {
    this._hideSplashWhenReady();
  }

  // AB#74965 - the dictionary can now arrive before the lazy public layout, so hide the splash only
  // when both are ready, otherwise the page flashes white between the splash and the form.
  private _hideSplashWhenReady(): void {
    if (this._childLayoutResolved && this._startupConfigService.isInitialized) {
      toggleSplashScreenVisibility();
    }
  }

  protected getLayoutImportPromiseFnByLayout(layout: PublicLayout): () => Promise<{ component: Type<PublicBaseLayoutComponent>; module: Type<any> }> {
    switch (this.currentLayout) {
      default: {
        return () =>
          import('./layouts/empty/public-empty-layout.component').then((c) => ({
            component: c.PublicEmptyLayoutComponent,
            module: c.PublicEmptyLayoutModule,
          }));
      }
    }
  }
}
